import { Button, Card, Grid, MenuItem, TextField } from '@mui/material'
import { pdf } from '@react-pdf/renderer'
import { message } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import queryString from 'query-string'
import { useCallback, useContext, useEffect, useState } from 'react'
import { RiPrinterLine } from 'react-icons/ri'
import { useNavigate, useParams } from 'react-router-dom'
import * as XLSX from 'xlsx'
import { AbilityContext } from '../../../../components/Ability'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent, {
  HeaderTagProps,
} from '../../../../components/Layouts/HeaderContent'
import { ERRORS_MESSAGE_MAPPER } from '../../../../constants/errors'
import { MAX_DONWLOAD_PAGE_SIZE, VAT_TYPES } from '../../../../constants/global'
import PageUrls from '../../../../constants/page-urls'
import { SHIPPING_PROVIDER_TEXT } from '../../../../constants/shipping-status'
import useAxios, { axiosInstance } from '../../../../hooks/useAxios'
import { useUser } from '../../../../hooks/useUser'
import {
  EOrderDateType,
  EOrderStatus,
  ESortOrder,
  IOrder,
  OrderSatausLabel,
  OrderSummary,
} from '../../../../types/order'
import { IUser, UserRole } from '../../../../types/user'
import { queryStringToArray } from '../../../../utils'
import OrderFilter, { IFilterMapped } from '../../components/OrderFilter'
import { IImportByOrdersForm } from '../../components/OrderImportLeadFormModal'
import { OrderMenuSelect } from '../../components/OrderMenuSelect'
import PDFReceipt from '../../components/PDFReceipt'
import OrderListTable from './components/OrderListTable'
import { isAllowNewFeature } from '../../../../constants/user'
import ConfirmModal from '../../../../components/ConfirmModal'
import { unique } from 'radash'

const Menus: any[] = []

export enum LeadExcelStatus {
  Success = 'success',
  Warning = 'warning',
}

const orderAbilityMap = new Map<EOrderStatus, string>([
  [EOrderStatus.AI, 'ai'],
  [EOrderStatus.CANCLELLED, 'cancelOrder'],
  [EOrderStatus.TRACKING, 'createdTracking'],
  [EOrderStatus.RETURN, 'returnProduct'],
  [EOrderStatus.RETURNED, 'returnedProduct'],
  [EOrderStatus.PENDING, 'sendOrder'],
  [EOrderStatus.TRANSIT, 'transitOrder'],
  [EOrderStatus.DELIVERED, 'deliveredOrder'],
  [EOrderStatus.SUCCESS, 'successOrder'],
])

const titleMap = new Map<EOrderStatus | string, string>([
  ['', 'รายการคำสั่งซื้อ'],
  [EOrderStatus.AI, 'รายการคำสั่งซื้อ AI'],
  [EOrderStatus.PENDING, 'รายการรอส่งสินค้า'],
  [EOrderStatus.TRACKING, 'รายการสร้าง Tracking แล้ว'],
  [EOrderStatus.CANCLELLED, 'รายการยกเลิก'],
  [EOrderStatus.RETURN, 'รายการคืนสินค้า'],
  [EOrderStatus.RETURNED, 'รายการคืนสินค้า (รับสินค้าแล้ว)'],
  [EOrderStatus.SUCCESS, 'รายการสำเร็จ'],
  [EOrderStatus.TRANSIT, 'รายการอยู่ระหว่างการขนส่ง'],
  [EOrderStatus.DELIVERED, 'รายการจัดส่งเรียบร้อย'],
  [EOrderStatus.SALEPAGE, 'รายการ SalePage'],
])

const generateTags = (
  status: EOrderStatus | string,
  total: OrderSummary | any,
): HeaderTagProps[] => {
  const commonTags = [
    {
      title: 'จำนวน',
      color: 'info',
      value: total?.count ?? 0,
      classifier: 'รายการ',
    },
    // {
    //   title: 'COD',
    //   color: 'warning',
    //   value: total?.codTotal ?? 0,
    //   classifier: 'บาท',
    // },
    // {
    //   title: 'โอน',
    //   color: 'primary',
    //   value: total?.bankTotal ?? 0,
    //   classifier: 'บาท',
    // },
    // {
    //   title: 'อัพเซลสำเร็จ',
    //   color: 'info',
    //   value: total?.upsaleTotal ?? 0,
    //   classifier: 'รายการ',
    // },
    // {
    //   title: 'อัพเซลไม่สำเร็จ',
    //   color: 'error',
    //   value: total?.unsuccessUpSaleTotal ?? 0,
    //   classifier: 'รายการ',
    // },
    // {
    //   title: 'ยอดขาย TELESALE',
    //   color: 'success',
    //   value: total?.upsalePriceTotal ?? 0,
    //   classifier: 'บาท',
    // },
  ]

  switch (status) {
    case EOrderStatus.PENDING:
      return [...commonTags]
    case EOrderStatus.SUCCESS:
      return [...commonTags]
    case EOrderStatus.CANCLELLED:
      return [...commonTags]
    case EOrderStatus.RETURN:
      return [...commonTags]
    case EOrderStatus.TRANSIT:
      return [...commonTags]
    case EOrderStatus.DELIVERED:
      return [...commonTags]
    default:
      return commonTags
  }
}

const OrderListPage = () => {
  const ability = useContext(AbilityContext)
  const navigate = useNavigate()
  const { status = '' } = useParams<{ status: EOrderStatus }>()
  const { merchant, user } = useUser()
  const queryStr = queryString.parse(window.location.search)
  const comissionUsername = queryStr.comission as string

  const [isConfirmModal, setIsConfirmModal] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const initialCursorHistory = (queryStr.ch as string)
    ? ((queryStr.ch as string).split(',').filter(Boolean) as string[])
    : []
  const [cursor, setCursor] = useState<{
    next?: string
    prev?: string
  }>({
    next: (queryStr.c as string) || undefined,
  })
  const [cursorHistory, setCursorHistory] =
    useState<string[]>(initialCursorHistory)

  const { c: _c, ch: _ch, ...queryStrWithoutCursor } = queryStr
  const query: any = {
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    ...queryStrWithoutCursor,
    products: queryStringToArray(queryStr.products),
    productGroups: queryStringToArray(queryStr.productGroups),
    categories: queryStringToArray(queryStr.categories),
    dateType: queryStr.dateType ?? EOrderDateType.CREATED,
    sortOrder: (queryStr.sortOrder as ESortOrder) ?? 'desc',
  }

  if (
    [
      EOrderStatus.AI,
      EOrderStatus.SALEPAGE,
      EOrderStatus.DELIVERED,
      EOrderStatus.TRACKING,
      EOrderStatus.PENDING,
      EOrderStatus.CANCLELLED,
      EOrderStatus.RETURN,
      EOrderStatus.RETURNED,
      EOrderStatus.SUCCESS,
    ].includes(status as EOrderStatus) ||
    !status
  ) {
    query.startDate = query.startDate
      ? query.startDate
      : dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
    query.endDate = query.endDate
      ? query.endDate
      : dayjs().endOf('month').format('YYYY-MM-DD')
  }

  if (comissionUsername) {
    query.commission = comissionUsername
    query.dateType = queryStr.dateType ? queryStr.dateType : 'orderDate'
  }

  //console.log('query', query)

  const [searchFilter, setSearchFilter] = useState<IFilterMapped>(query)
  const [filter, setFilter] = useState<IFilterMapped>(query)
  const [printReceipt, setPrintReceipt] = useState<{
    vat: VAT_TYPES
    size: 'A4' | '80mm'
    showDate: string
    isCustomPayment: boolean
    showProductInPackaging: boolean
  }>({
    vat: VAT_TYPES.EXCLUDE,
    size: 'A4',
    showDate: 'order',
    isCustomPayment: false,
    showProductInPackaging: false,
  })

  const [selectedOrders, setSelectedOrders] = useState<IOrder[]>([])

  const onFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      setFilter(newFilter)
    },
    [filter],
  )

  const navigateWithCursor = (
    nextFilter: IFilterMapped,
    nextHistory: string[],
    nextC?: string,
  ) => {
    const newQuery = queryString.stringify({
      ...nextFilter,
      c: nextC || undefined,
      ch: nextHistory.length ? nextHistory.join(',') : undefined,
    })
    navigate(`${PageUrls.Orders.Index}/${status}?${newQuery}`, {
      replace: true,
    })
  }

  const handleSearch = (newFilter: IFilterMapped) => {
    const filter = {
      ...newFilter,
      page: 1,
    }
    setFilter(filter)
    setSearchFilter(filter)
    setCursor({})
    setCursorHistory([])
    navigateWithCursor(filter, [], undefined)
  }

  const handlePageChange = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    navigateWithCursor(newFilter, cursorHistory, cursor.next)
  }

  const handleNext = (nextCursor: string) => {
    if (!nextCursor) return
    const newHistory = [...cursorHistory, nextCursor]
    setCursorHistory(newHistory)
    setCursor({ next: nextCursor })
    navigateWithCursor(filter, newHistory, nextCursor)
  }

  const handlePrev = () => {
    const newHistory = cursorHistory.slice(0, -1)
    setCursorHistory(newHistory)
    const last = newHistory[newHistory.length - 1]
    setCursor(last ? { next: last } : {})
    navigateWithCursor(filter, newHistory, last)
  }

  const handlePerPageChange = (perPage: number) => {
    const next = { ...filter, perPage, page: 1 }
    setFilter(next)
    setSearchFilter(next)
    setCursor({})
    setCursorHistory([])
    navigateWithCursor(next, [], undefined)
  }

  // flipping the sort direction invalidates every cursor already collected
  const handleSortOrderChange = (sortOrder: ESortOrder) => {
    const next = { ...filter, sortOrder, page: 1 }
    setFilter(next)
    setSearchFilter(next)
    setCursor({})
    setCursorHistory([])
    navigateWithCursor(next, [], undefined)
  }

  useEffect(() => {
    if (!comissionUsername) {
    }

    setSelectedOrders([])
    const abilityAction =
      orderAbilityMap.get(status as EOrderStatus) ?? 'myOrder'

    if (abilityAction && !ability.can('manage', 'Order', abilityAction)) {
      navigate(PageUrls.Home)
    }
  }, [status, comissionUsername])

  const params: any = {
    ...query,
    showTotal: '1',
    statusCall:
      (query?.statusCall as any) == 'all' ? undefined : query.statusCall,
    statusOrderShowTracking:
      (query?.statusOrderShowTracking as any) == 'all'
        ? undefined
        : query.statusOrderShowTracking,
    statusShowCrmTelesale:
      (query?.statusShowCrmTelesale as any) == 'all'
        ? undefined
        : query.statusShowCrmTelesale,
    dateType: (query?.dateType as any) == 'all' ? undefined : query.dateType,
    trackingProvider:
      query?.trackingProvider === 'all' ? undefined : query?.trackingProvider,
    paymentMethod:
      query?.paymentMethod === 'all' ? undefined : query?.paymentMethod,
    providerStatus:
      query?.providerStatus === 'all' ? undefined : query?.providerStatus,
    sort: '',
  }

  // console.log('------------', params.status)
  // console.log('------------', comissionUsername)

  if (!status || comissionUsername) {
    // console.log('------------', status)
    delete params.status
    if (comissionUsername && params.exceptStatus) {
      params.exceptStatus = [EOrderStatus.CANCLELLED, EOrderStatus.RETURNED]
    }
    // console.log('------------')
  }

  if (queryStr.ignoreCancel === 'true' && !params.exceptStatus) {
    params.exceptStatus = [EOrderStatus.CANCLELLED]
  }

  if (!comissionUsername) {
    delete params.comissionUsername
  }

  if (status) {
    params.status = status
  }

  if (
    [
      EOrderStatus.DELIVERED,
      EOrderStatus.RETURN,
      EOrderStatus.TRANSIT,
    ].includes(status as EOrderStatus)
  ) {
    params.sort = EOrderDateType.TRACKING
  }

  const cursorParams = {
    ...params,
    page: undefined,
    nextCursor: cursor.next,
    prevCursor: cursor.prev,
  }

  const ordersList = useAxios<{
    records: IOrder[]
    nextCursor: string | null
    prevCursor: string | null
    hasNext: boolean
    hasPrev: boolean
    total: OrderSummary
  }>({
    method: 'GET',
    url: '/order/v1/cursor',
    params: cursorParams,
  })

  const handleOnDownload = useCallback(
    async (date: Dayjs) => {
      let loop = true
      let page = 1,
        perPage = MAX_DONWLOAD_PAGE_SIZE
      const orders: IOrder[] = []
      let startDate = params.startDate
      let endDate = params.endDate

      if (
        !startDate ||
        !endDate ||
        dayjs(endDate).diff(dayjs(startDate), 'day') > 31
      ) {
        startDate = date.startOf('month').format('YYYY-MM-DD')
        endDate = date.endOf('month').format('YYYY-MM-DD')
      }
      while (loop) {
        try {
          const ordersResult = await axiosInstance.get('/order', {
            params: {
              ...params,
              page,
              perPage,
              startDate,
              endDate,
            },
          })
          page++
          if (!ordersResult?.data?.records.length) {
            loop = false
            break
          }
          orders.push(...ordersResult.data.records)
          if (ordersResult?.data?.count < perPage) {
            loop = false
            break
          }
        } catch (e) {
          message.warning('เกิดข้อผิดพลาดในการดาวน์โหลดข้อมูลบางส่วน')
          break
        }
      }
      if (!orders.length) {
        message.warning('ไม่พบข้อมูล')
        return
      }
      const rows = orders?.map((order: IOrder) => {
        const isCod = order.paymentMethod === 'COD'
        const oldTrackingsA = order?.trackings?.map(t => t.trackingNumber)
        const oldTrackingsB = order?.trackings?.map(t => t.trackingRecentNumber)
        const oldTrackings = unique([...(oldTrackingsA ?? []), ...(oldTrackingsB ?? [])]).filter(t => t !== order.trackingCode).filter(Boolean).join(', ')
        return {
          สถานะ: OrderSatausLabel?.[order?.status ?? ''] ?? order.status,
          รหัสคำสั่งซื้อ: `${order.code}`,
          หมายเลขพัสดุ: order.trackingCode ?? '-',
          หมายเลขพัสดุเดิม: oldTrackings || '-',
          ขนส่ง: SHIPPING_PROVIDER_TEXT?.[order?.trackingProvider ?? ''] ?? '-',
          ชื่อลูกค้า: order.recipient.name,
          เบอร์โทร: order.recipient.phone,
          ที่อยู่: `${order.recipient.address} ${order.recipient.subDistrict} ${order.recipient.district} ${order.recipient.province} ${order.recipient.zipcode}`,
          social: order.recipient?.social || '-',
          จำนวน: order.quantity,
          สินค้า: order.items
            .map((product) => {
              return `${product.productName} (${product.quantity}) ขนาด: ${product.meta?.size || '-'
                } สี: ${product.meta?.color || '-'} น้ำหนัก: ${product.meta?.weight || '-'
                }
              `
            })
            .join(', '),
          COD: isCod ? order.total : '',
          โอน: isCod ? '' : order.total,
          สร้างคำสั่งซื้อโดย: order.actor,
          รับค่าคอมโดย: order.items
            .map((product) => {
              return `${product.commissionUsername}`
            })
            .join(', '),
          ช่องทางการขาย: order.distribution?.name ?? '-',
          วันที่คำสั่งซื้อ: dayjs(order.orderDate).format('DD/MM/YYYY HH:mm'),
          วันที่จัดส่ง: order.pickUpAt
            ? dayjs(order.pickUpAt).format('DD/MM/YYYY HH:mm')
            : '-',
          หมายเหตุ: order.note,
          วันที่สร้าง: dayjs(order.createdAt).format('DD/MM/YYYY HH:mm'),
          วันที่อัพเดท: dayjs(order.updatedAt).format('DD/MM/YYYY HH:mm'),
        }
      })
      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      XLSX.writeFile(wb, `order-${status}.xlsx`)
      message.success('ดาวน์โหลดสำเร็จ')
    },
    [status, params],
  )

  const handleSelectMenuOrder = async (status: EOrderStatus) => {
    if (status === EOrderStatus.CANCLELLED) {
      const hasTrackingCount = selectedOrders.filter(
        (order) => order.trackingCode,
      ).length
      if (hasTrackingCount > 0) {
        message.warning(
          `ไม่สามารถยกเลิกคำสั่งซื้อที่มี Tracking แล้วได้ จำนวน: ${hasTrackingCount}`,
        )
        return
      }
    }

    try {
      setSelectedOrders([])
      await axiosInstance.put('/order/status', {
        status,
        objectIds: selectedOrders.map((order) => order.objectId),
      })
      ordersList.mutate()
      message.success('เปลี่ยนสถานะสำเร็จ')
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }

  const handleChangeStatusTelesale = async (username: string) => {
    try {
      setSelectedOrders([])
      await axiosInstance.put('/order/status', {
        status: EOrderStatus.TELESALE,
        assignTelesaleBy: username,
        objectIds: selectedOrders.map((order) => order.objectId),
      })
      ordersList.mutate()
      message.success('ย้าย Telesale สำเร็จ')
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }

  const handleImportLeadByOrders = async (data: IImportByOrdersForm) => {
    try {
      setSelectedOrders([])
      const leads = await axiosInstance.post<
        {
          status?: LeadExcelStatus
          message?: string
        }[]
      >(`/lead/import-by-orders`, {
        ...data,
        objectIds: selectedOrders.map((order) => order.objectId),
      })

      const ordersStatus = selectedOrders.map((order, index) => ({
        order,
        leadMessage: leads.data[index],
      }))
      // const messageStatus = `นำเข้าทะเบียนลูกค้าสำเร็จ ${ordersStatus.filter(order => order.leadMessage.status === LeadExcelStatus.Success).map(order => order.order.code).join(', ')} รายการ ไม่สำเร็จ ${ordersStatus.filter(order => order.leadMessage.status === LeadExcelStatus.Warning).map(order => `${order.order.code} เนื่องจาก ${order.leadMessage.message}`).join(', ')} รายการ`
      const messageStatus = `นำข้อมูลเข้าแล้ว ${ordersStatus.filter(
        (order) => order.leadMessage.status === LeadExcelStatus.Success,
      ).length
        } รายการ ยังไม่หมดอายุ ${ordersStatus.filter(
          (order) => order.leadMessage.status === LeadExcelStatus.Warning,
        ).length
        } รายการ`
      if (
        ordersStatus.some(
          (order) => order.leadMessage.status === LeadExcelStatus.Warning,
        )
      ) {
        message.warning(messageStatus)
      } else {
        message.success(messageStatus)
      }
      await ordersList.mutate()
    } catch (e: any) {
      const messageError =
        ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
        'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
  }

  const openPDF = async () => {
    const blob = await pdf(
      <PDFReceipt
        isCustomPayment={printReceipt.isCustomPayment}
        showProductInPackaging={printReceipt.showProductInPackaging}
        merchant={merchant}
        orders={selectedOrders}
        size={printReceipt.size}
        vatType={printReceipt.vat}
        showDate={printReceipt.showDate}
      />,
    ).toBlob()
    const pdfURL = URL.createObjectURL(blob)
    window.open(pdfURL, '_blank')
  }

  const onUpdateTrackingStatus = useCallback(async () => {
    setIsLoading(true)
    setIsConfirmModal(false)
    if (!filter.trackingProvider) {
      message.error(
        'กรุณาค้นหาคำสั่งซื้อจาก ช่องทางการขนส่ง ก่อนทำการอัพเดตสถานะพัสดุ',
      )
      setIsLoading(false)
      return
    }

    if (selectedOrders.length === 0) {
      message.error('กรุณาเลือกออเดอร์')
      setIsLoading(false)
      return
    }

    if (selectedOrders.length > 30) {
      message.error('กรุณาเลือกออเดอร์ไม่เกิน 30 รายการ')
      setIsLoading(false)
      return
    }

    try {
      await axiosInstance.post(
        `/trackings/${filter.trackingProvider.toLowerCase()}/status`,
        {
          orders: selectedOrders.map((order) => order.objectId),
        },
      )
      setSelectedOrders([])
      await ordersList.mutate()
      message.success('อัพเดตสถานะพัสดุสำเร็จ')
    } catch (error) {
      const statusCode = (error as any)?.response?.status ?? 500
      if (statusCode === 404) {
        message.error(
          'ผู้ให้บริการพัสดุยังไม่เปิดให้บริการ กรุณาเลือกผู้ให้บริการพัสดุอื่น',
        )
        setIsLoading(false)
        return
      }
      message.error('อัพเดตสถานะพัสดุไม่สำเร็จ')
    } finally {
      setIsLoading(false)
    }
  }, [filter.trackingProvider, selectedOrders])

  const enableButtonActions = [
    EOrderStatus.AI,
    EOrderStatus.SALEPAGE,
    EOrderStatus.PENDING,
    EOrderStatus.TRACKING,
    EOrderStatus.RETURN,
    EOrderStatus.TRANSIT,
    EOrderStatus.SUCCESS,
    EOrderStatus.DELIVERED,
  ].includes(status as EOrderStatus)

  const enablePrintReceipt =
    ![EOrderStatus.CANCLELLED, EOrderStatus.RETURNED, EOrderStatus.SALEPAGE, EOrderStatus.AI].includes(
      status as EOrderStatus,
    ) && ability.can('manage', 'setting', 'printReceipt')

  const enableButtonActionsTracking =
    [EOrderStatus.TRACKING, EOrderStatus.TRANSIT].includes(
      status as EOrderStatus,
    ) &&
    isAllowNewFeature(user as IUser) &&
    filter.trackingProvider

  return (
    <ContentWrapper>
      <Helmet title={`${titleMap.get(status)}`} />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title={`${titleMap.get(status)}`}
            subTitle={`วันที่ ${dayjs(filter.startDate).format(
              'DD/MM/YYYY',
            )} - ${dayjs(filter.endDate).format('DD/MM/YYYY')}`}
            routes={Menus.filter((menu) => menu.status === status)}
            descriptions={titleMap.get(status) ?? ''}
            tags={
              merchant.config?.display?.totalOrder ||
                [UserRole.ADMIN, UserRole.MERCHANT].some(
                  (role) => (user.roles as UserRole[])?.includes(role),
                )
                ? generateTags(status, ordersList.data?.total ?? {})
                : undefined
            }
          />
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}
      >
        <OrderFilter
          filter={filter}
          status={status as EOrderStatus}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
          onDownload={handleOnDownload}
        />
        {enablePrintReceipt && selectedOrders.length > 0 && (
          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} lg={2}>
              <TextField
                onChange={(e) =>
                  setPrintReceipt({
                    ...printReceipt,
                    vat: e.target.value as VAT_TYPES,
                  })
                }
                fullWidth
                label="ภาษี"
                value={printReceipt.vat}
                select
              >
                <MenuItem value={'exclude'}>แสดง vat 7% (นอก)</MenuItem>
                <MenuItem value={'include'}>แสดง vat 7% (ใน)</MenuItem>
                <MenuItem value={'non-vat'}>ไม่แสดง vat 7%</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} lg={2}>
              <TextField
                onChange={(e) =>
                  setPrintReceipt({
                    ...printReceipt,
                    showDate: e.target.value,
                  })
                }
                fullWidth
                label="แสดงวันที่"
                value={printReceipt.showDate}
                select
              >
                <MenuItem value={'order'}>แสดง วันที่ของคำสั่งซื้อ</MenuItem>
                <MenuItem value={'date'}>แสดง วันที่ปัจุบัน</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} lg={2}>
              <TextField
                onChange={(e) =>
                  setPrintReceipt({
                    ...printReceipt,
                    isCustomPayment: e.target.value === 'true',
                  })
                }
                fullWidth
                label="กำหนดการชำระเงิน"
                value={printReceipt.isCustomPayment}
                select
              >
                <MenuItem value={'true'}>กำหนดเอง</MenuItem>
                <MenuItem value={'false'}>อัตโนมัติ</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} lg={2}>
              <TextField
                onChange={(e) =>
                  setPrintReceipt({
                    ...printReceipt,
                    showProductInPackaging: e.target.value === 'true',
                  })
                }
                fullWidth
                label="แสดงสินค้าในเซ็ต"
                value={printReceipt.showProductInPackaging}
                select
              >
                <MenuItem value={'true'}>แสดง</MenuItem>
                <MenuItem value={'false'}>ไม่แสดง</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Button
                variant="contained"
                size="large"
                color="primary"
                onClick={openPDF}
                sx={{ height: '100%' }}
                startIcon={<RiPrinterLine />}
              >
                พิมพ์ใบเสร็จ
              </Button>
            </Grid>
          </Grid>
        )}
        {enableButtonActions && selectedOrders.length > 0 && (
          <>
            <ConfirmModal
              open={isConfirmModal}
              onClose={() => setIsConfirmModal(false)}
              onConfirm={onUpdateTrackingStatus}
              title={'ยืนยันการอัพเดตสถานะพัสดุ'}
              message={'คุณต้องการอัพเดตสถานะพัสดุหรือไม่?'}
            />
            <OrderMenuSelect
              status={status as EOrderStatus}
              include={true}
              onClick={(value: EOrderStatus) => {
                handleSelectMenuOrder(value)
              }}
              onClickImport={(data: IImportByOrdersForm) => {
                handleImportLeadByOrders(data)
              }}
              onClickTelesale={(username: string) => {
                handleChangeStatusTelesale(username)
              }}
              total={selectedOrders.length}
              enableButtonActionsTracking={!!enableButtonActionsTracking}
              onClickTracking={() => setIsConfirmModal(true)}
            />
          </>
        )}
        <OrderListTable
          statusOrder={status}
          isLoading={ordersList.isLoading || isLoading}
          data={ordersList.data?.records ?? []}
          selectedData={selectedOrders}
          setSelectedData={setSelectedOrders}
          filter={filter}
          onFilterChange={handleSearch}
          handlePageChange={handlePageChange}
          total={ordersList.data?.total?.count ?? 0}
          hasNext={ordersList.data?.hasNext ?? false}
          hasPrev={cursorHistory.length > 0}
          onNext={() => handleNext(ordersList.data?.nextCursor ?? '')}
          onPrev={handlePrev}
          onPerPageChange={handlePerPageChange}
          pageIndex={cursorHistory.length + 1}
          sortOrder={query.sortOrder}
          onSortOrderChange={handleSortOrderChange}
        />
      </Card>
    </ContentWrapper>
  )
}

export default OrderListPage
